/* eslint-disable */
(function($){
    const App = {
        bellCityMobMenu() {
            $("#mobile-bars").sidr({
              name: "sidr",
              side: "left",
              speed: 400,
              displace: false,
              timing: "ease",
              onOpen() {
                $("#mobile-bars i").removeClass("fa-bars").addClass("fa-times");
                $("body").css({
                  position: "fixed",
                  width: "100%",
                  background: "rgba(0, 0, 0, 0.5)",
                });
                $("#sidr").css('display', 'block');
              },
              onClose() {
                $("#mobile-bars i").removeClass("fa-times").addClass("fa-bars");
                $("body").css({
                  position: "static",
                  width: "auto",
                  background: "transparent",
                });
                
              },
            });
            $('#sidr').css('display', 'block');
            $(document).on("click", function (e) {
              if (!$(e.target).closest("#sidr").length) {
                  $.sidr( 'close', 'sidr' );
              }
            });
      
            /*sidr sub menu*/
            const sidrParentMenu = $("#sidr #mobile-view li.menu-item-has-children");
            const sidrSubmenu = $("#sidr #mobile-view ul.sub-menu");
            const parentAncor = $(
              "#sidr #mobile-view li.menu-item-has-children"
            ).children("a");
      
            $('<i class="fa-solid fa-chevron-down"></i>').appendTo(parentAncor);
            sidrSubmenu.hide();
            sidrParentMenu.children("a").on("click", function (e) {
              e.preventDefault();
              $(this).next("ul.sub-menu").stop().slideToggle();
              $(this).children("i").toggleClass("fa-chevron-down fa-chevron-up");
            });
            $('ul#mobile-view li.menu-item-has-children a').css({'display': 'flex', 'justify-content' : 'space-between', 'align-items' : 'center'});
            
          },
          taxiVenobox(){
            $('.image-popup').venobox({
                bgcolor: '#3C92CA',
                numeration: true,
                spinner: 'wandering-cubes'
            });
            
          },
          bellCitySlide(){
            var swiper = new Swiper(".bellSwiper", {
              spaceBetween: 30,
              effect: "fade",
              loop: true,
              slidesPerView: 1,
              autoplay: {
                delay: 3000,
                disableOnInteraction: false,
              },
            });
          },
          productCarousel(){
            var swiper = new Swiper(".swiper-product", {
              slidesPerView: 1,
              spaceBetween: 30,
              loop: true,
              setWrapperSize: true,
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
              pagination: {
                el: ".swiper-pagination",
                clickable: true,
              },
              breakpoints: {
                640: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                  },
                  768: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                  },
                  1024: {
                    slidesPerView: 4,
                    spaceBetween: 50,
                  },
              },
            });
          },
        productSlider(){
            let swiper = new Swiper(".product-slider-nav", {
                spaceBetween: 10,
                slidesPerView: 4,
                freeMode: true,
                watchSlidesProgress: true,
                slideToClickedSlide: true,
                threshold: 5
              });
            let swiper2 = new Swiper(".product-slider", {
                spaceBetween: 10,
                navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                },
                thumbs: {
                  swiper: swiper,
                },
              });
        },
        backtrackModal(){
         $(document).ready(function(){
            $("#modalBtn").on("click", function(){
              $("body").addClass("modal-open");
            });
            $(".closeModal").on("click", function(){
              $("body").removeClass("modal-open");
            });
          });
        },
        taxiNavSticky(){
            var nav = $('.main-navigation-area');
            var stickyOffset = nav.offset().top;
            var navHeight = nav.outerHeight();
            
            // Create a placeholder to maintain the original space
            var placeholder = $('<div class="nav-placeholder"></div>').hide();
            nav.before(placeholder); // Insert placeholder before the nav
    
            // On scroll, check the position and toggle the sticky class
            $(window).scroll(function() {
                if ($(window).scrollTop() >= stickyOffset) {
                    placeholder.show().height(navHeight);
                    nav.addClass('nav-sticky');
                } else {
                    placeholder.hide();
                    nav.removeClass('nav-sticky');
                }
            });
        },
          
    }

    App.init = function(){
        App.bellCityMobMenu();
        App.bellCitySlide();
        // App.taxiSlide();
        // App.backtrackVenobox();
        // App.productCarousel();
        // App.productSlider();
    }
    $(function(){
        App.init();
        
    });
})(jQuery);